import * as React from 'react';

type ToastShowFn = (
  name: string,
  severity: 'success' | 'info' | 'warn' | 'error',
  summary: string,
  detail?: React.ReactNode,
  sticky?: boolean
) => void;
type ToastClearFn = (name: string) => void;

let toastShow: ToastShowFn = () => {};
let toastClear: ToastClearFn = () => {};

export const registerToastShow = (fn: ToastShowFn) => {
  toastShow = fn;
};

export const registerToastClear = (fn: ToastClearFn) => {
  toastClear = fn;
};

export const showToast: ToastShowFn = (name, severity, summary, detail?, sticky = false) => {
  toastShow(name, severity, summary, detail, sticky);
};

export const clearToast: ToastClearFn = (name) => {
  toastClear(name);
};
